import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { FiArrowRight } from "@/lib/icons";

/**
 * Hero section - matches design-5 exactly
 * Two column split: cream left, dark image right
 */
export function HeroSection() {
  return (
    <section>
      <div className="grid lg:grid-cols-2 min-h-[600px] lg:min-h-[85vh]">
        {/* Left Column - Cream Background */}
        <div className="bg-cream flex items-center">
          <div className="px-6 py-16 md:px-12 lg:px-16 xl:px-20 max-w-2xl">
            {/* Label */}
            <p className="section-label mb-6">Mortgage Broker</p>

            {/* Headline */}
            <h1 className="font-serif text-4xl md:text-5xl lg:text-[3.5rem] xl:text-6xl leading-[1.1] tracking-tight">
              Find the right home loan,
              <br />
              <span className="italic">with expert guidance</span>
            </h1>

            {/* Description */}
            <p className="mt-6 text-lg text-muted-foreground max-w-md">
              Access 70+ lenders through one application. We compare rates,
              handle the paperwork, and guide you to settlement.
            </p>

            {/* CTAs */}
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <Button
                asChild
                size="lg"
                className="btn-pill bg-primary text-primary-foreground hover:bg-primary/90 px-6 h-12"
              >
                <Link to="/contact">
                  Get Started
                  <FiArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
              <Button
                asChild
                variant="ghost"
                size="lg"
                className="text-foreground hover:bg-transparent hover:underline underline-offset-4 px-2 h-12"
              >
                <Link to="/calculators">Explore Calculators</Link>
              </Button>
            </div>

            {/* Trust Indicators */}
            <div className="mt-12">
              <p className="text-xs text-muted-foreground uppercase tracking-wider mb-4">
                Your Local Mortgage Experts
              </p>
              <div className="flex flex-wrap items-center gap-4 md:gap-6 text-sm text-muted-foreground">
                <span className="font-medium">AFG Partner</span>
                <span className="hidden sm:inline">•</span>
                <span className="font-medium">70+ Lenders</span>
                <span className="hidden sm:inline">•</span>
                <span className="font-medium">4.9★ Rating</span>
                <span className="hidden sm:inline">•</span>
                <span className="font-medium">Australia-Wide</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column - Dark with Image */}
        <div className="bg-primary relative hidden lg:block">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url('/hero-image.jpg')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            {/* Overlay */}
            <div className="absolute inset-0 bg-primary/40" />
          </div>
        </div>
      </div>
    </section>
  );
}
